// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"191":"6c8c31ab","208":"ab511c1c","263":"8421ef05","583":"f5c7c090","691":"6d869a0d"}[chunkId] + ".chunk.js";
};